import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function ChiriasStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Chiriasul este o firma / societate comerciala"
          checked={!!data.chiriasPJ}
          onChange={() => update("chiriasPJ")(!data.chiriasPJ)}
        />
      </div>

      {data.chiriasPJ ? (
        <>
          <InputField label="Denumire societate" value={data.chiriasFirma} onChange={update("chiriasFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.chiriasFirma} />
          <InputField label="CUI" value={data.chiriasCUI} onChange={update("chiriasCUI")} placeholder="ex: RO12345678" required half error={errors.chiriasCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.chiriasRegCom} onChange={update("chiriasRegCom")} placeholder="ex: J40/1234/2020" half error={errors.chiriasRegCom} />
          <InputField label="Sediu social" value={data.chiriasSediu} onChange={update("chiriasSediu")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.chiriasSediu} />
          <InputField label="Reprezentant legal" value={data.chiriasReprezentant} onChange={update("chiriasReprezentant")} placeholder="ex: Ionescu Maria" required error={errors.chiriasReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.chiriasNume} onChange={update("chiriasNume")} placeholder="ex: Ionescu Maria" required error={errors.chiriasNume} />
          <InputField label="Adresa de domiciliu" value={data.chiriasAdresa} onChange={update("chiriasAdresa")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.chiriasAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.chiriasCNP} onChange={update("chiriasCNP")} placeholder="ex: 2234567890123" half error={errors.chiriasCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.chiriasCI} onChange={update("chiriasCI")} placeholder="ex: MZ 654321" half error={errors.chiriasCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
